import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';
import { RestProviderService } from '../../../services/rest-provider/rest-provider.service';
import { RequestModel } from '../../../models/request/request-model';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'sem-hidden-value',
  templateUrl: './sem-hidden-value.component.html',
  styleUrls: ['./sem-hidden-value.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: SemHiddenValueComponent, multi: true }
  ]
})
export class SemHiddenValueComponent extends ValueAccessorBase<string> implements OnInit {

  @Input() apiEndpoint: string = '';
  @Input() buttonLabel: string;
  @Input() payloadValues: string[];

  errorText: string = 'Napaka pri nalaganju podatkov';  
  customErrorText: string = '';
  unauthorizedText: string = 'Nimate pravic za ogled podatka';
  loadingText: string = 'Nalaganje...';
  isValueVisible: boolean = false;
  isLoading: boolean = false;
  hasError: boolean = false;
  isUnauthorized: boolean = false;
  hiddenValue: string = '';

  super() { }

  ngOnInit() {
    console.log(this.payloadValues);
    super.ngOnInit();
  }

  async onButtonClick() {
    
    if (this.isValueVisible || this.isLoading) {
      return;
    }

    if (!this.apiEndpoint) {
      //console.error('sem-hidden-value: apiEndpoint is required');
      this.hasError = true;
      return;
    }

    this.isLoading = true;
    this.hasError = false;
    this.isUnauthorized = false;
    this.customErrorText = '';

    console.log(this.dfms.globalModel);
    console.log(this.model);

    try {
      // Use POST request with RequestModel as per codebase pattern
      const requestModel = new RequestModel();
      requestModel.url = this.apiEndpoint;
      requestModel.contentType = "application/json";
      requestModel.responseType = "application/json";

      // Build payload from payloadValues configuration
      const payload: any = {};
      
      if (this.payloadValues && this.payloadValues.length > 0) {
        for (const payloadItem of this.payloadValues) {
          if (payloadItem["FieldName"] && payloadItem["Value"]) {
            // Get value from model using dfms.getValue
            let fieldValue = this.dfms.getValue(this.dfms.globalModel, payloadItem["Value"]);
            if(fieldValue == null || typeof fieldValue == "undefined"){
              fieldValue = this.dfms.getValue(this.model, payloadItem["Value"]);
            }
            if(fieldValue){
              payload[payloadItem["FieldName"]] = fieldValue;
            }            
          }
        }
      }

      requestModel.data = {"Envelope": payload};
      //console.log('API Payload:', payload);

      const response = await firstValueFrom(this.restProviderService.getDataPOST<any>(requestModel));
      
      if (response && response.Metadata && response.Metadata.ServerMessageMetadata) {
        const messageType = response.Metadata.ServerMessageMetadata.MessageType;
        const message = response.Metadata.ServerMessageMetadata.Message;
        
        if (messageType === 1) {
          // Success
          this.hiddenValue = message || '';
          this.isValueVisible = true;
        } else if (messageType === 2) {
          // Error from server - use custom message from API
          this.customErrorText = message || this.errorText;
          this.hasError = true;
        } else {
          // Unknown message type
          this.hasError = true;
        }
      } else {
        this.hasError = true;
      }
    } catch (error) {
      console.error('Error fetching hidden value:', error);
      
      // Check if error is unauthorized (401 or 403)
      if (error && error.status && (error.status === 401 || error.status === 403)) {
        this.isUnauthorized = true;
        this.hasError = false;
      } else {
        this.hasError = true;
        this.isUnauthorized = false;
      }
    } finally {
      this.isLoading = false;
    }
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.hiddenValue);
      //console.log('Text copied successfully');
    } catch (err) {
      //console.error('Failed to copy text: ', err);
    }
  }

  protected override valueChanged(): void {
    // Reset visibility when value changes
    this.isValueVisible = false;
    this.hiddenValue = '';
    this.hasError = false;
    this.isUnauthorized = false;
    this.customErrorText = '';
  }
}